export function getUserRegistryStatusEndpoint(): string {
    return '/user-registry-status';
}

export function getCustomerIdEndpoint(): string {
    return '/user-customer-id';
}
